<template>
  <div class="articlePage pageWhite pagePadding">
    <el-form ref="form" :model="formData" :rules="rules"
             label-width="100px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title" placeholder="请输入标题" clearable/>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <Editor v-model="formData.content"/>
      </el-form-item>
      <el-form-item class="text-center">
        <el-button :loading="isSubmit" type="primary" @click="submit">确认并保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  import Editor from '@/components/tinymce/index.vue'

  export default {
    components: {
      Editor
    },
    data () {
      return {
        actionID:'',
        formData: {
          title: '',
          content: ''
        },
        rules: {
          title: {required: true, message: '请输入标题', trigger: 'blur'},
          content: {required: true, message: '请输入内容', trigger: 'blur'}
        },
        isSubmit: false
      }
    },
    created(){
      this.actionID = this.$route.params['id']
      if (this.actionID) {
        this.getDesc(this.actionID)
      }
    },
    methods: {
      getDesc(id) {
        this.$api.descNotice(id, res => {
          for (let j in this.formData) {
            this.formData[j] = res[j]
          }
        })
      },
      submit () {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.isSubmit = true
            if(this.actionID){
              this.$api.editNotice(this.actionID,this.formData, () => {
                this.$message.success('保存成功')
                this.$router.back()
              }, () => {
                this.isSubmit = false
              })
            }else{
              this.$api.addNotice(this.formData, () => {
                this.$message.success('保存成功')
                this.$router.back()
              }, () => {
                this.isSubmit = false
              })
            }
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/noticeAction.vue